<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('studentEnrollment.updateSession') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-loading-banner :loading="loading">
      <ts-card-wrapper>
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required">{{
              $t('studentEnrollment.session')
            }}</label>
            <a-select
              v-model="model.session_id"
              style="width: 100%"
              @change="onChangeSession"
              :options="sessionList"
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="2"
              :max-tag-text-length="10"
            ></a-select>
            <div class="validate" v-if="errors.has('session_id')">
              {{ errors.first('session_id') }}
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <label class="required">{{
              $t('studentEnrollment.studyTime')
            }}</label>
            <a-select
              :disabled="model.session_id.length > 1"
              v-model="model.ac_st_id"
              style="width: 100%"
              :options="study_times"
              :allowClear="true"
            ></a-select>
            <div class="validate" v-if="errors.has('ac_st_id')">
              {{ errors.first('ac_st_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right mt-2">
            <ts-button
              class="primary"
              color="primary"
              :waiting="waiting"
              @click="update"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'updateSession',
  props: ['edit_data'],
  data() {
    return {
      model: {
        session_id: [],
        ac_st_id: null
      },
      errors: new Errors(),
      study_times: [],
      loading: false,
      sessionList: [
        {
          value: 1,
          label: 'Session 1'
        },
        {
          value: 2,
          label: 'Session 2'
        }
      ],
      waiting: false
    }
  },
  created() {
    this.fetchStudyTime()
  },
  methods: {
    ...mapActions('studentEnrollment', ['getStudyTime']),
    fetchStudyTime() {
      this.loading = true
      this.getStudyTime()
        .then(response => {
          this.study_times = response.data.map(el => ({
            value: el.ac_st_id,
            label: el.study_time
          }))
        })
        .finally(() => {
          this.loading = false
          this.setEditData()
        })
    },
    onChangeSession() {
      if (this.model.session_id.length > 1) {
        this.model.ac_st_id = this.edit_data.academic_class.academic_study_time.ac_st_id
      }
      this.model.ac_st_id = this.model.ac_st_id
    },
    setEditData() {
      this.model = {
        session_id: this.edit_data.session_id
          ? this.edit_data.session_id.split(',').map(Number)
          : [],
        ac_st_id:
          this.edit_data.session_id == '1,2' ||
          this.edit_data.session_id == '2,1'
            ? this.edit_data.academic_class.academic_study_time.ac_st_id
            : this.edit_data.ac_st_id
            ? this.edit_data.ac_st_id
            : null
      }
    },
    update() {
      this.waiting = true
      this.$store
        .dispatch('studentEnrollment/updateSession', {
          st_class_id: this.edit_data.st_class_id,
          ...this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('before-close')
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
